module.exports = function() {
  return new Worker(__webpack_public_path__ + "abaaf58ec68a96ff0c20.worker.js");
};